<style>
    .save-group-buttons .dropdown-menu{
        width: 331px;
    }
    .save-group-buttons .scroll-container{
        overflow-y: auto;
        max-height: 322px;
    }
    .save-group-buttons .group-dropdown-item{
        cursor: pointer;
        padding-left: 12px;
        padding-top: 8px;
        padding-bottom: 8px;
        /*margin: 8px 0;*/
        margin: 0px 0;
        /*transition: 0.1s;*/
        border-radius: 4px;
        font-size: 14px;
    }
    .save-group-buttons .group-dropdown-item:hover{
        background: var(--border-color);
/*        background: var(--primary);
        color: white;*/
    }
    .save-group-buttons .group-dropdown-item:last-child{
        margin-bottom: 0;
    }
    .save-group-buttons .save-group-buttons-button{
        padding: 7px 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        /*max-width: 160px;*/
        max-width: 126px;
        font-weight: 600;
    }

    @media (max-width:500px) {
        .save-group-buttons .save-group-buttons-button{
            min-width: 48px;
            min-height: 48px;
        }
        .btn-saved{
            min-width: 48px;
            min-height: 48px;
        }
    }

</style>

<script>
    import {shopifyHelperMixin} from "../../mixins/shopifyHelperMixin";
    import saveGroupDropdown from './saveGroupDropdown';

    export default {
        props: ['item'],
        data: function () {
            return {
                loading: {
                    quick_save: false
                },
                groups: [],
                selected_group: null
            };
        },
        mixins: [shopifyHelperMixin],
        components: {
            saveGroupDropdown
        },
        created: function () {
            var self = this;
            this.groups = window.my_groups || [];
            this.suggestGroup();

            window.bus.$on('update-selected-group', function(data){
                if(data.group && self.item === data.item){
                    self.setSelectedGroup(data.group);
                }
            });

            window.bus.$on('created-group', function(data){
                if(data.group && self.item === data.item){
                    self.setSelectedGroup(data.group);
                }
            });

        },
        mounted: function () {

        },
        computed: {
            is_saved: function(){
                var groups = this.groups || [];
                for(var i=0; i < groups.length; i++){
                    var group = groups[i];
                    var item_ids = group.item_ids || [];
                    if(item_ids.includes(this.id)){
                        return true;
                    }
                }
                return false;
            },
            bookmark_count: function(){
                var count = 0;
                var groups = this.groups || [];
                for(var i=0; i < groups.length; i++){
                    var group = groups[i];
                    var item_ids = group.item_ids || [];
                    if(item_ids.includes(this.id)){
                        count++;
                    }
                }
                return count;
            },
            id: function(){
                if(this.type === 'shopify_product'){
                    return this.item.id;
                }
            },
            type: function(){
                if(this.item.className === 'TG\\Models\\Meloquent\\Shopify\\Product'){
                    return 'shopify_product';
                }
            },
            thumbnail_url: function(){
                if(this.type === 'shopify_product'){

                    if(this.item.images && this.item.images.length && this.item.images[0].src){
                        return this.resizeImage(this.item.images[0].src, '_x200');
                    }
                    return this.item.image_url;

                }
            }
        },
        watch: {

        },
        methods: {
            showSaveToListModal: function(){
                if(!this.auth_user){
                    window.bus.$emit('show_login_form');
                    return;
                }
                window.bus.$emit('show-save-to-list-modal', {
                    item: this.item
                });
            },
            quickSave: function(){
                if(!this.auth_user){
                    window.bus.$emit('show_login_form');
                    return;
                }
                if(this.loading.quick_save){
                    return;
                }
                var self = this;
                self.loading.quick_save = true;
                var url = '/api/v5/group/quick-save';
                var params = {
                    item: this.item,
                    type: this.type
                };
                if(this.selected_group){
                    params.group_id = this.selected_group.uuid;
                }
                axios.post(url, params).then(function (response) {
                    var group = response.data.data;
                    self.updateGroup(group);
                    self.loading.quick_save = false;
//                    $(self.$el).modal('hide');

                    self.suggestGroup(group);

                    self.showSavedSnackbar(group);

                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.quick_save = false;
                    self.showErrorMessage(error);
                });
            },
            suggestGroup: function(preferred_group){
                var selected_group = null;

                //Use the preferred group if it has this item
                if(preferred_group){
                    if(this.hasItem(preferred_group)){
                        selected_group = preferred_group;
                    }
                }

                if(!selected_group){
                    //Use the first group that has the item
                    for(var i=0; i < this.groups.length; i++){
                        var group = this.groups[i];
                        if(this.hasItem(group)){
                            selected_group = group;
                            break;
                        }
                    }
                }

                if(!selected_group){
                    //Use the preferred group if given one or use the first group in list
                    if(preferred_group){
                        selected_group = preferred_group;
                    } else {
                        selected_group =  this.groups[0];
                    }
                }

                this.setSelectedGroup(selected_group);
            },
            hasItem: function(group){
                var item_ids = group.item_ids || [];
                var id = this.item.id || this.item.uuid;
                return item_ids.includes(id);
            },
            setSelectedGroup: function(group){
                this.selected_group = group;
            },
            showSavedSnackbar: function(group){
                var self = this;
                var item_ids = group.item_ids || [];
                var snackbar = {
                    image_url: this.thumbnail_url,
                    pos: 'bottom-center'
                };

                if(item_ids.includes(this.id)){
                    snackbar.text = 'Saved to <br><strong>' + group.name + '</strong>';
                    snackbar.action_text = 'Undo';
                    snackbar.action_callback = function(){
                        self.removeGroupItem(group);
                    };
                } else {
                    snackbar.text = 'Removed from <br><strong>' + group.name + '</strong>';
                }
                if(typeof RDSnackbar === 'object'){
                    RDSnackbar.show(snackbar);
                } else {
                    Snackbar.show(snackbar);
                }
            },
            removeGroupItem: function(group){
                var self = this;

                var url = '/api/v5/group/' + group.uuid + '/remove-item';
                var params = {
                    item: this.item
                };

                axios.post(url, params).then(function (response) {
                    var group_data = response.data.data;
                    if(group_data){
                        self.updateGroup(group_data);
                    }

                    RDSnackbar.show({
                        text: 'Item removed from list!'
                    });

                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.showErrorMessage(error);
                });
            },
            updateGroup: function(group_data){
                var groups = this.groups || [];
                var index = this.groups.map(function(g){
                    return g.uuid;
                }).indexOf(group_data.uuid);
                if(index > -1){
                    //Group exists. Update it with new data
                    Object.assign(groups[index], group_data);
                } else {
                    //Group isn't in array. Add it groups
                    groups.push(group_data);
                }
                this.groups = groups;
            },
        },
        filters: {

        }
    };
</script>

<template>

    <div class="row row-xs justify-content-end flex-nowrap save-group-buttons">
        <div class="col text-right">
            <button class="btn btn-default rounded-pill save-group-buttons-button overlay-hide" type="button" @click="showSaveToListModal" title="Save to List">
                <i class="fas fa-chevron-down fa-fw"></i>
                <span v-if="selected_group">{{selected_group.name}}</span>
            </button>
        </div>
        <div class="col-auto overlay-hide">
            <button class="btn rounded-pill btn-saved" :class="[is_saved ? 'btn-primary' : 'btn-default']" style="padding: 7px 8px;" @click="quickSave" title="Quick Save to Default List">
                <span v-if="is_saved">
                    <i class="fas fa-bookmark fa-fw"></i>
                    Saved
                    <span v-if="bookmark_count > 1">({{bookmark_count}})</span>
                </span>
                <i class="far fa-bookmark fa-fw" v-else></i>
            </button>
        </div>
    </div>

</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/group/saveGroupButtons.vue